{
	"_embedded": {
		"item": [
			{
				"ctn": "872989200552",
				"ctvs": ["1", "2", "3"],
				"availableInCountries": ["DE", "FR", "IT"],
				"isAssigned": false,
				"_links": {
					"self": {
						"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment/a1111111-1111-1111-1111-111111111111"
					},
					"collection": {
						"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment"
					}
				}
			},
			{
				"ctn": "872989200553",
				"ctvs": ["10", "11"],
				"isAssigned": false,
				"_links": {
					"self": {
						"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment/b2222222-2222-2222-2222-222222222222"
					},
					"collection": {
						"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment"
					}
				}
			},
			{
				"ctn": "872989200554",
				"ctvs": ["5"],
				"isAssigned": false,
				"_links": {
					"self": {
						"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment/c3333333-3333-3333-3333-333333333333"
					},
					"collection": {
						"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment"
					}
				}
			}
		]
	},
	"_links": {
		"self": {
			"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment"
		},
		"item": [
			{
				"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment/a1111111-1111-1111-1111-111111111111"
			},
			{
				"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment/b2222222-2222-2222-2222-222222222222"
			},
			{
				"href": "https://dev.backend.ka.philips.com/api/ProductVariantAssignment/c3333333-3333-3333-3333-333333333333"
			}
		]
	},
	"page": {
		"size": 10,
		"totalElements": 3,
		"totalPages": 1,
		"number": 0
	}
}
